/**
 * TanStack Query hooks for `eu-us-data-privacy-framework-registration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	euUsDataPrivacyFrameworkRegistrationQueryKeys,
	type CreateEuUsDataPrivacyFrameworkRegistrationBody,
	type ListEuUsDataPrivacyFrameworkRegistrationResponse,
	type EuUsDataPrivacyFrameworkRegistrationRow,
} from "./api";

export function useEuUsDataPrivacyFrameworkRegistrationList(): UseQueryResult<ListEuUsDataPrivacyFrameworkRegistrationResponse, Error> {
	return useQuery({
		queryKey: euUsDataPrivacyFrameworkRegistrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useEuUsDataPrivacyFrameworkRegistrationCreate(): UseMutationResult<EuUsDataPrivacyFrameworkRegistrationRow, Error, CreateEuUsDataPrivacyFrameworkRegistrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: euUsDataPrivacyFrameworkRegistrationQueryKeys.all });
		},
	});
}

export function useEuUsDataPrivacyFrameworkRegistrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: euUsDataPrivacyFrameworkRegistrationQueryKeys.all });
		},
	});
}
